(function () {
  var WORKER_URL = "https://absolutely-natural-newsletter.goyalstudio.workers.dev";
  var TURNSTILE_SRC = "https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit";
  var submitBound = false;
  var waitTimer = null;

  function hasTurnstileScript() {
    return Boolean(
      document.querySelector('script[src*="challenges.cloudflare.com/turnstile/v0/api.js"]')
    );
  }

  function loadTurnstileScript() {
    if (hasTurnstileScript()) {
      return;
    }

    var script = document.createElement("script");
    script.src = TURNSTILE_SRC;
    script.async = true;
    script.defer = true;
    document.head.appendChild(script);
  }

  function hasTurnstileApi() {
    return Boolean(window.turnstile && typeof window.turnstile.render === "function");
  }

  function footerWidgets() {
    return document.querySelectorAll("[data-newsletter-worker] [data-turnstile-widget]");
  }

  function isWidgetRendered(widget) {
    return Boolean(
      widget.getAttribute("data-widget-id") ||
        widget.querySelector("iframe") ||
        widget.querySelector('input[name="cf-turnstile-response"]')
    );
  }

  function renderFooterWidgets() {
    var widgets = footerWidgets();
    var remaining = 0;
    var i;
    var widget;
    var widgetId;

    for (i = 0; i < widgets.length; i++) {
      widget = widgets[i];

      if (!widget.getAttribute("data-sitekey")) {
        continue;
      }

      if (isWidgetRendered(widget) || widget.getAttribute("data-turnstile-rendering") === "true") {
        continue;
      }

      widget.setAttribute("data-turnstile-rendering", "true");

      try {
        widgetId = window.turnstile.render(widget, {
          sitekey: widget.getAttribute("data-sitekey"),
          theme: "auto",
          size: "normal",
        });

        if (widgetId) {
          widget.setAttribute("data-widget-id", widgetId);
        } else {
          widget.removeAttribute("data-turnstile-rendering");
          remaining += 1;
        }
      } catch (error) {
        widget.removeAttribute("data-turnstile-rendering");
        remaining += 1;
        console.error(
          "footer_newsletter_turnstile_render_failed",
          error && error.message ? error.message : error
        );
      }
    }

    return remaining === 0 && widgets.length > 0;
  }

  function waitForTurnstileAndDom() {
    var attempts = 0;
    var maxAttempts = 100;

    function attemptRender() {
      if (footerWidgets().length === 0 || !hasTurnstileApi()) {
        return false;
      }

      return renderFooterWidgets();
    }

    if (waitTimer) {
      clearInterval(waitTimer);
      waitTimer = null;
    }

    if (attemptRender()) {
      return;
    }

    waitTimer = setInterval(function () {
      attempts += 1;

      if (attemptRender() || attempts >= maxAttempts) {
        clearInterval(waitTimer);
        waitTimer = null;
      }
    }, 100);
  }

  function getToken(form) {
    var widget = form.querySelector("[data-turnstile-widget]");
    var widgetId = widget && widget.getAttribute("data-widget-id");

    if (!widgetId || !window.turnstile || typeof window.turnstile.getResponse !== "function") {
      return "";
    }

    try {
      return window.turnstile.getResponse(widgetId) || "";
    } catch (error) {
      return "";
    }
  }

  function resetTurnstile(form) {
    var widget = form.querySelector("[data-turnstile-widget]");
    var widgetId = widget && widget.getAttribute("data-widget-id");

    if (!widgetId || !window.turnstile || typeof window.turnstile.reset !== "function") {
      return;
    }

    try {
      window.turnstile.reset(widgetId);
    } catch (error) {
      // Ignore reset failures so the form can still show an error.
    }
  }

  function showError(form, message) {
    var errorEl = form.querySelector("[data-newsletter-error]");
    var successEl = form.querySelector("[data-newsletter-success]");

    if (successEl) {
      successEl.hidden = true;
    }

    if (errorEl) {
      errorEl.textContent = message;
      errorEl.hidden = false;
    }
  }

  function getSource(form) {
    return (form.getAttribute("data-newsletter-source") || "footer").trim() || "footer";
  }

  function rememberPopupSuccess(form) {
    if (getSource(form) !== "popup") {
      return;
    }

    var popup = form.closest("[data-section-type='newsletter-popup']");
    var sectionId =
      (popup && popup.getAttribute("data-section-id")) || form.getAttribute("data-section-id");

    if (!sectionId || typeof window.Cookies === "undefined" || !window.Cookies.set) {
      return;
    }

    var hasReminder = popup && popup.getAttribute("data-has-reminder") === "true";
    var reminderAppeared = sessionStorage.getItem("reminderAppeared") === "true";

    if ((hasReminder && reminderAppeared) || !hasReminder) {
      window.Cookies.set("newsletter-" + sectionId, "opened", {
        path: "/",
        expires: 200,
      });
    }
  }

  function showSuccess(form) {
    var errorEl = form.querySelector("[data-newsletter-error]");
    var fields = form.querySelector("[data-newsletter-fields]");
    var successEl = form.querySelector("[data-newsletter-success]");

    if (errorEl) {
      errorEl.hidden = true;
    }

    if (fields) {
      fields.hidden = true;
    }

    if (successEl) {
      successEl.hidden = false;
    }

    rememberPopupSuccess(form);
  }

  function setBusy(form, busy) {
    var button = form.querySelector("[data-newsletter-submit]");
    if (button) {
      button.disabled = busy;
    }
  }

  function hardenForms() {
    var forms = document.querySelectorAll("[data-newsletter-worker]");
    var i;

    for (i = 0; i < forms.length; i++) {
      forms[i].setAttribute("action", "#");
      forms[i].setAttribute("method", "post");
    }
  }

  function onSubmit(event) {
    var form = event.target;

    if (!form || !form.matches || !form.matches("[data-newsletter-worker]")) {
      return;
    }

    event.preventDefault();
    event.stopPropagation();
    if (typeof event.stopImmediatePropagation === "function") {
      event.stopImmediatePropagation();
    }

    var emailInput = form.querySelector("[data-newsletter-email]");
    var honeypotInput = form.querySelector("[data-newsletter-honeypot]");
    var email = emailInput ? String(emailInput.value || "").trim() : "";
    var honeypot = honeypotInput ? String(honeypotInput.value || "").trim() : "";
    var genericError =
      form.getAttribute("data-error-generic") || "Unable to complete signup. Please try again.";
    var verificationError =
      form.getAttribute("data-error-verification") || "Please complete the verification.";

    if (emailInput && typeof emailInput.reportValidity === "function" && !emailInput.reportValidity()) {
      return;
    }

    var token = getToken(form);
    if (!token && !honeypot) {
      showError(form, verificationError);
      return;
    }

    setBusy(form, true);

    fetch(WORKER_URL, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        email: email,
        turnstileToken: token,
        honeypot: honeypot,
        source: getSource(form),
      }),
    })
      .then(function (response) {
        return response
          .json()
          .then(function (data) {
            return data;
          })
          .catch(function () {
            return {};
          });
      })
      .then(function (data) {
        if (data && data.ok) {
          showSuccess(form);
          return;
        }

        showError(form, (data && data.error) || genericError);
        resetTurnstile(form);
      })
      .catch(function () {
        showError(form, genericError);
        resetTurnstile(form);
      })
      .then(function () {
        setBusy(form, false);
      });
  }

  function init() {
    loadTurnstileScript();
    hardenForms();
    waitForTurnstileAndDom();

    if (!submitBound) {
      submitBound = true;
      document.addEventListener("submit", onSubmit, true);
    }
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }

  document.addEventListener("shopify:section:load", init);
})();
